import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { League } from '../league.model';

@JsonObject('LeaguesResultsResponse')
export class LeaguesResultsResponse extends ApiResultsResponse<League> {

  @JsonProperty('results', [League])
  override results: League[] = [];
}
